import { type AnchorProps, Kbd } from "@mantine/core"
import { useTranslation } from "react-i18next"
import type { TTag } from "@/types"
import { peopleURL } from "@/utils"

import { AppLink } from "../AppLink"

interface IProps extends AnchorProps {
  tag: TTag
}

export function TagLink({ tag, ...props }: IProps) {
  const { t } = useTranslation("tags")
  return (
    <AppLink href={`${peopleURL}?params={"where":{"tags":"${tag.id}"}}`} {...props}>
      <Kbd>{t(tag.id)}</Kbd>
    </AppLink>
  )
}
